__turbopack_context__.v({
  "component": "index-module__ddlGzG__component",
  "hide-for-large": "index-module__ddlGzG__hide-for-large",
  "hide-for-large-only": "index-module__ddlGzG__hide-for-large-only",
  "hide-for-medium": "index-module__ddlGzG__hide-for-medium",
  "hide-for-medium-only": "index-module__ddlGzG__hide-for-medium-only",
  "hide-for-small-only": "index-module__ddlGzG__hide-for-small-only",
  "imageContainer": "index-module__ddlGzG__imageContainer",
  "li": "index-module__ddlGzG__li",
  "panel": "index-module__ddlGzG__panel",
  "row": "index-module__ddlGzG__row",
  "show-for-large": "index-module__ddlGzG__show-for-large",
  "show-for-large-only": "index-module__ddlGzG__show-for-large-only",
  "show-for-medium": "index-module__ddlGzG__show-for-medium",
  "show-for-medium-only": "index-module__ddlGzG__show-for-medium-only",
  "show-for-small-only": "index-module__ddlGzG__show-for-small-only",
  "subtitle": "index-module__ddlGzG__subtitle",
  "title": "index-module__ddlGzG__title",
  "u-color-black": "index-module__ddlGzG__u-color-black",
  "u-color-blue": "index-module__ddlGzG__u-color-blue",
  "u-color-midnight": "index-module__ddlGzG__u-color-midnight",
  "u-color-primary-dark": "index-module__ddlGzG__u-color-primary-dark",
  "u-color-red": "index-module__ddlGzG__u-color-red",
  "u-color-white": "index-module__ddlGzG__u-color-white",
  "u-theme-black": "index-module__ddlGzG__u-theme-black",
  "u-theme-blue": "index-module__ddlGzG__u-theme-blue",
  "u-theme-dark": "index-module__ddlGzG__u-theme-dark",
  "u-theme-light": "index-module__ddlGzG__u-theme-light",
  "u-theme-red": "index-module__ddlGzG__u-theme-red",
  "u-theme-white": "index-module__ddlGzG__u-theme-white",
  "ul": "index-module__ddlGzG__ul",
});
